<template>
  <div id="eInvoiceDataList">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
          <el-breadcrumb-item>电子发票明细报表</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             label-width="80px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       clearable
                       filterable
                       @change="loadPark"
                       style="width:200px;">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场库::">
            <el-select v-model="pageSearch.fParkID"
                       filterable
                       placeholder="请选择场库"
                       style="width:200px;"
                       clearable>
              <el-option v-for="item in park_list"
                         :key="item.fParkID"
                         :label="item.fParkName"
                         :value="item.fParkID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间::">
            <el-date-picker v-model="startTime"
                            style="width:200px"
                            type="date"
                            :clearable="false"
                            :picker-options="startMonthOption"
                            @change="selectStartMonth"
                            placeholder="选择开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间::">
            <el-date-picker v-model="endTime"
                            style="width:200px"
                            :clearable="false"
                            type="date"
                            :picker-options="endMonthOption"
                            @change="selectEndMonth"
                            placeholder="选择结束时间">
            </el-date-picker>
          </el-form-item>

        </el-col>
        <el-col :span="24">
          <el-form-item label="发票类型::">
            <el-select v-model="pageSearch.feInvType"
                       clearable
                       filterable
                       placeholder="请选择支付模式"
                       style="width:200px;">
              <el-option v-for="item in feInvTypeID_list"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车牌号码::">
            <el-input placeholder="请输入车牌号码"
                      v-model="pageSearch.fPlateCode"
                      class="search"></el-input>
          </el-form-item>
          <el-form-item label="上传状态::">
            <el-select v-model="pageSearch.fUpStatus"
                       clearable
                       filterable
                       placeholder="请选择上传状态"
                       style="width:200px;">
              <el-option v-for="item in payStatus_list"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开票状态::">
            <el-select v-model="pageSearch.fCBStatus"
                       clearable
                       filterable
                       placeholder="请选择开票状态"
                       style="width:200px;">
              <el-option v-for="item in fCBStatus_list"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="page_list">查询</el-button>
            <el-button type="success"
                       size="small"
                       icon="el-icon-share"
                       :loading="export_loading"
                       v-if="is_export"
                       @click="exportData">{{export_msg}}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  ref="dt"
                  :summary-method="getSummaries"
                  show-summary
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           label="序号">
          </el-table-column>
          <el-table-column prop="fOpLastTime"
                           width="160"
                           label="操作时间">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           width="80"
                           label="客户编号">
          </el-table-column>
          <el-table-column prop="fParkNo"
                           width="80"
                           label="场库编号">
          </el-table-column>
          <el-table-column prop="fParkName"
                           label="场库名称">
             <template slot-scope="scope">
                  <el-link type="primary"  @click="viewParkInfo(scope.row)">{{scope.row.fParkName}}</el-link>
              </template>
          </el-table-column>
          <el-table-column prop="fOutChnlNo"
                           width="95"
                           label="通道编号">
          </el-table-column>
          <el-table-column prop="fOutChnlName"
                           label="通道名称">
          </el-table-column>
          <el-table-column prop="fPlateCode"
                           width="100"
                           label="车牌">
          </el-table-column>
          <el-table-column prop="fAmountStr"
                           width="100"
                           align="right"
                           label="支付金额(元)">
          </el-table-column>
          <el-table-column prop="feInvType"
                           width="115"
                           label="发票类型">
          </el-table-column>
          <el-table-column prop="fUpTimes"
                           width="80"
                           label="上传次数">
          </el-table-column>
          <el-table-column prop="fUpStatusName"
                           width="80"
                           label="上传状态">
          </el-table-column>
          <el-table-column prop="fInvNo"
                           width="105"
                           label="发票号码">
          </el-table-column>
          <el-table-column prop="fCBStatusType"
                           width="80"
                           label="开票状态">
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           fixed="right"
                           width="310">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="success"
                         @click="handleInfo(scope.$index, scope.row)">查看</el-button>
              <el-button size="mini"
                         type="primary"
                         @click="handleDetail(scope.$index, scope.row)">详情</el-button>
              <el-button size="mini"
                         type="info"
                         @click="handleRetransmit(scope.$index, scope.row)">重传</el-button>
              <el-button size="mini"
                         type="danger"
                         @click="invoiceHongChong(scope.$index, scope.row)"
                         v-if="scope.row.feInvTypeID==99500||scope.row.feInvTypeID==99900">红冲</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <roadSideCarInfoView ref="child"
                         :type="2"
                         v-if="is_roadSide"></roadSideCarInfoView>
    <carInfoView ref="child"
                 v-else
                 reportActiveName="pageData"
                 :type="2"></carInfoView>
  <parkView ref="childPark"
              parkActiveName="parkList"
              :choiceCusts="cust_list"></parkView>
    <el-dialog :title="dialogTitle"
               width="55%"
               top="7vh"
               v-loading="true"
               class="einvoiceDialog"
               :visible.sync="dialogVisible"
               v-dialogDrag>
      <el-form label-width="110px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="最后操作时间">
              <el-input v-model="form.fOpLastTime"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户编号">
              <el-input v-model="form.fCustNo"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="服务器IP">
              <el-input v-model="form.fSvrIPAddr"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="订单号">
              <el-input v-model="form.fBusDataID"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="场库名称">
              <el-input v-model="form.fParkName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="通道名称">
              <el-input v-model="form.fOutChnlName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="车牌号码">
              <el-input v-model="form.fPlateCode"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="记录ID">
              <el-input v-model="form.fBusID"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="支付金额">
              <el-input v-model="form.fAmountStr"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="执行起始时间">
              <el-input v-model="form.fStartTime"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="执行结束时间">
              <el-input v-model="form.fEndTime"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="执行时间">
              <el-input v-model="form.fUrlTime"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="电子发票类型">
              <el-input v-model="form.feInvType"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="电子发票URL">
              <el-input v-model="form.feInvUrl"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!--<el-row class="fRemark_row">
          <el-col :span="24">
            <el-form-item label="发票参数">
              <el-input type="textarea"
                        v-model="form.feInvParms"
                        :disabled="true"
                        class="fRemark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>-->
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input v-model="form.fRemark"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="fRemark_row">
          <el-col :span="24">
            <el-form-item label="URL参数">
              <el-input type="textarea"
                        v-model="form.fUrlParms"
                        :disabled="true"
                        class="fRemark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="fRemark_row_big">
          <el-col :span="24">
            <el-form-item label="URL返回值">
              <el-input type="textarea"
                        v-model="form.fUrlRetData"
                        :disabled="true"
                        class="fRemark_big"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="上传次数">
              <el-input v-model="form.fUpTimes"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="上传状态">
              <el-input v-model="form.fUpStatusName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
              <el-col :span="8">
            <el-form-item label="开票状态">
              <el-input v-model="form.fCBStatusType"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="商户订单号">
              <el-input v-model="form.fBusOrderNo"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="支付方式">
              <el-input v-model="form.fPayTypeName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
              <el-col :span="8">
            <el-form-item label="缴费类型">
              <el-input v-model="form.fDataSrcType"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
                <el-row>
          <el-col :span="8">
            <el-form-item label="发票流水号">
              <el-input v-model="form.fInvOrderNo"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="不含税金额">
              <el-input v-model="form.fNoTaxAmtStr"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
              <el-col :span="8">
            <el-form-item label="税额">
              <el-input v-model="form.fTaxAmtStr"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="开票时间">
              <el-input v-model="form.fInvTime"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票号码">
              <el-input v-model="form.fInvNo"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
              <el-col :span="8">
            <el-form-item label="发票代码">
              <el-input v-model="form.fInvCode"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="发票链接">
              <el-input v-model="form.fInvPDFUrl"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import parkView from '../../components/parkView'
import carInfoView from '../../components/carInfoView'
import roadSideCarInfoView from '../../components/roadSideCarInfoView'
import { report as api } from '../../api/report'
import * as park from '../../api/park'
import * as user from '../../api/user'
import $ from 'jquery'
export default {
  name: 'eInvoiceDataList',
  components: { carInfoView, roadSideCarInfoView, parkView },
  data () {
    return {
      lock: false,
      is_roadSide: false,
      park_list: [],
      feInvTypeID_list: [
        { value: '99100', label: '99100:容津发票' },
        { value: '99200', label: '99200:E开云发票' },
        { value: '99500', label: '99500:银联商务发票' },
        { value: '99600', label: '99600:云票儿' },
        { value: '99700', label: '99700:航信发票' },
        { value: '99800', label: '99800:航天诺诺发票' },
        { value: '99850', label: '99850:诺诺发票自用型' },
        { value: '99900', label: '99900:北京航天发票' }
      ],
      payStatus_list: [
        { value: 1, label: '成功' },
        { value: 0, label: '失败' }
      ],
      fCBStatus_list: [
        { value: 1, label: '已开票' },
        { value: 0, label: '未开票' },
        { value: 2, label: '开票中' },
        { value: 3, label: '已红冲' }
      ],
      dialogVisible: false,
      dialogTitle: '',
      title: '业务数据中心',
      form: {},
      is_export: false,
      tableHeight: 0,
      loading: false,
      export_loading: false,
      export_msg: '导出',
      pageData: [],
      cust_list: [],
      startTime: '',
      endTime: '',
      pageCount: 0,
      total: {
        total: 0,
        successTotal: 0,
        errorTotal: 0
      },
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        feInvType: '',
        fCustID: '',
        fParkID: '',
        fCustTypeID: '',
        fStartTime: '',
        fEndTime: '',
        fPlateCode: '',
        isExport: 0
      },
      startMonthOption: {
        disabledDate: (time) => {
          var today = new Date()
          var times = new Date(today.getFullYear(), today.getMonth() - 2, 1, 0, 0, 0)
          return time.getTime() < times.getTime()
        }
      },
      endMonthOption: {
      }
    }
  },
  methods: {
    page_list (index) {
      var starttime = this.$dateFormat(this.startTime, 'yyyy-MM-dd')
      var endtime = this.$dateFormat(this.endTime, 'yyyy-MM-dd')
      if (starttime !== endtime && (this.pageSearch.fCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      this.loading = true
      this.pageSearch.fStartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd 00:00:00')
      this.pageSearch.fEndTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd 23:59:59')
      this.pageSearch.isExport = 0
      this.pageSearch.fCustTypeID = this.is_roadSide ? 1 : 0
      api.eInvoiceDataList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data || []
            this.pageCount = data.Data.count
            this.total = { total: data.Data.total, successTotal: data.Data.successTotal, errorTotal: data.Data.errorTotal }
            setTimeout(() => { this.$refs['dt'].doLayout() }, 100)
          } else {
            this.$message.error('提示：' + data.Msg)
          //  this.$message.error('提示：加载电子发票明细数据失败')
          }
        }
      })
    },
    getSummaries (param) {
      var sums = []
      sums[0] = '合计'
      sums[5] = '总额：' + this.total.total
      var dts = document.querySelectorAll('.el-table__footer-wrapper tbody.has-gutter>tr>td')
      if (dts && dts.length >= 5) {
        $(dts[5]).attr('colspan', 5)
        $(dts[5]).css('text-align', 'right')
      }
      return sums
    },
    viewParkInfo (row) {
      this.$refs.childPark.viewPark(row, true, row.fParkID)
    },
    loadPark (fCustID) {
      // 加载离场数据列表
      // this.page_list()
      this.pageSearch.fParkID = ''
      this.park_list = []

      if (!fCustID) { return }
      // 加载场库
      park.getParkList({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.park_list = data.Data
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.page_list(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.page_list(val)
    },
    getCurrentMonthLast (dt) {
      var date = dt
      var currentMonth = date.getMonth()
      var nextMonth = ++currentMonth
      var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
      var oneDay = 1000 * 60 * 60 * 24
      var lastTime = new Date(nextMonthFirstDay - oneDay)
      var month = parseInt(lastTime.getMonth() + 1)
      var day = lastTime.getDate()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return new Date(date.getFullYear() + '-' + month + '-' + day)
    },
    selectStartMonth () {
      var endMonth = this.endTime.getMonth()
      var startMonth = this.startTime.getMonth()
      if (endMonth !== startMonth) {
        this.endTime = this.getCurrentMonthLast(this.startTime)
      }
      this.endMonthOption = {
        disabledDate: (time) => {
          if (this.startTime !== '') {
            var endMonth = this.startTime.getMonth()
            var minMonth = time.getMonth()
            return time.getTime() < this.startTime.getTime() || minMonth !== endMonth
          }
        }
      }
    },
    selectEndMonth () {
      var endMonth = this.endTime.getMonth()
      var startMonth = this.startTime.getMonth()
      if (endMonth !== startMonth) {
        this.startTime = new Date(this.endTime.getFullYear(), this.endTime.getMonth(), 1, 0, 0, 0)
      }
      this.startMonthOption = {
        disabledDate: (time) => {
          if (this.endTime !== '') {
            // var endMonth = this.endTime.getMonth()
            // var minMonth = time.getMonth()
            var today = new Date()
            var times = new Date(today.getFullYear(), today.getMonth() - 2, 1, 0, 0, 0)
            return time.getTime() < times.getTime()
          }
        }
      }
    },
    exportData () {
      var starttime = this.$dateFormat(this.startTime, 'yyyy-MM-dd')
      var endtime = this.$dateFormat(this.endTime, 'yyyy-MM-dd')
      if (starttime !== endtime && (this.pageSearch.fCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.pageSearch.fStartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd 00:00:00')
      this.pageSearch.fEndTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd 23:59:59')
      this.pageSearch.isExport = 1
      this.pageSearch.fCustTypeID = this.is_roadSide ? 1 : 0
      this.export_loading = true
      this.export_msg = '导出中……'
      var fileName = '所有客户'
      if ((this.pageSearch.fCustID || '').trim().length > 0) {
        var custArr = (this.cust_list || []).filter((item) => {
          return item.fCustID === this.pageSearch.fCustID
        })
        fileName = custArr.length > 0 ? custArr[0].unionName : ''
      }
      api.eInvoiceDataList(this.pageSearch).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_电子发票报表.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    init () {
      // var firstDay = new Date()
      // firstDay.setDate(1)
      // this.startTime = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate(), 0, 0, 0)
      var today = new Date()
      this.startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
      this.endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
      var type = this.$route.query.type
      this.is_roadSide = type === '1'
      if (this.is_roadSide) {
        this.title = '路测数据中心'
      } else {
        this.title = '业务数据中心'
      }
      this.selectStartMonth()
      park.getCustByGroup({ fCustTypeID: 0 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data
            if (this.cust_list && this.cust_list.length === 1) {
              this.pageSearch.fCustID = this.cust_list[0].fCustID
              this.loadPark(this.pageSearch.fCustID)
            }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
      user.getCurrentUserPers({ perTypeId: 69500 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.is_export = data.Data.data.is_export
            }
          } else {
            this.$message.error('提示：加载当前用户权限信息失败')
          }
        }
      })
    },
    handleInfo (index, row) {
      this.$refs.child.handleInfo(row)
    },
    handleDetail (index, row) {
      this.form = row
      this.dialogTitle = '【' + row.fCustNo + '】' + row.fParkName + '-电子发票详情'
      this.dialogVisible = true
    },
    handleRetransmit (index, row) {
      var fTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd 00:00:00')
      if (row && row !== null && typeof (row) !== 'undefined') {
        var msg = '电子发票数据重传'
        if (row.fUpStatus === '1') {
          // msg = '当前电子发票数据已经上传成功,不需要重传'
          // this.$message.error(msg)
          // return false
          this.$confirm('将客户[' + row.fCustNo + ']的场库[' + row.fParkName + ']' + msg + ', 是否继续?', '提示', {
            cancelButtonText: '取消',
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => {
            api.retransmitById({
              fBigRowID: row.fBigRowIDs,
              fStartTime: fTime
            }).then(res => {
              if (res && res.data) {
                let { status, data } = res
                if (status === 200) {
                  if (data.IsOk) {
                    this.$message({
                      type: 'success',
                      message: '重传成功'
                    })
                    this.page_list(0)
                  } else {
                    this.$message.error(data.Msg)
                  }
                }
              }
            })
          }).catch(() => { })
        } else {
          api.retransmitById({
            fBigRowID: row.fBigRowIDs,
            fStartTime: fTime
          }).then(res => {
            if (res && res.data) {
              let { status, data } = res
              if (status === 200) {
                if (data.IsOk) {
                  this.$message({
                    type: 'success',
                    message: '重传成功'
                  })
                  this.page_list(0)
                } else {
                  this.$message.error(data.Msg)
                }
              }
            }
          })
        }
      }
    },
    invoiceHongChong (index, row) {
      if (row && row !== null && typeof (row) !== 'undefined') {
        var msg = '电子发票数据重传'
        if (row.fCBStatus === '0') {
          msg = '当前电子发票状态未开票，不能进行红冲'
          this.$message.error(msg)
          return false
        } else if (row.fCBStatus === '2') {
          msg = '当前电子发票开票中，不能进行红冲'
          this.$message.error(msg)
          return false
        } else if (row.fCBStatus === '3') {
          msg = '当前电子发票已红冲，不能重复操作'
          this.$message.error(msg)
          return false
        } else if (row.fCBStatus === '4') {
          msg = '当前电子发票红冲中，不能重复操作'
          this.$message.error(msg)
          return false
        } else { // this.$confirm('将发票号码[' + row.fCustNo + ']的场库[' + row.fParkName + ']' + msg + ', 是否继续?', '提示', {
          if (!this.lock) {
            this.$confirm('将发票号码为[' + row.fInvNo + ']的发票进行红冲操作, 是否继续?', '提示', {
              cancelButtonText: '取消',
              confirmButtonText: '确定',
              type: 'warning'
            }).then(() => {
              this.lock = true
              api.invoiceHongChong(row).then(res => {
                if (res && res.data) {
                  let { status, data } = res
                  if (status === 200) {
                    if (data.IsOk) {
                      this.lock = false
                      this.$message({
                        type: 'success',
                        message: '操作成功'
                      })
                      this.page_list(0)
                    } else {
                      this.$message.error(data.Msg)
                    }
                  }
                }
              })
            }).catch(() => { })
          } else {
            msg = '请勿重复点击'
            this.$message.error(msg)
            return false
          }
        }
      }
    },
    setImgHeight () {
      var formHeight = $('.form_right').height()
      var fplateHeight = $('.fplate_info .el-image').height()
      var carImgHeight = $('.car_img .img').height()
      if (formHeight && fplateHeight > 0) {
        var height = (formHeight - fplateHeight - carImgHeight) / 2
        $('.fplate_info').css({ 'margin-top': height + 'px', 'margin-bottom': height + 'px' })
      }
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 250
      obj.tableHeight = clientHeight
    }
  },
  created () {

  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        Object.assign(this.$data, this.$options.data())
        this.init()
      },
      // 深度观察监听
      deep: true
    }
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style >
/* dialog弹出框样式 */
#eInvoiceDataList .einvoiceDialog .el-dialog {
  min-width: 840px;
}
#eInvoiceDataList .einvoiceDialog .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#eInvoiceDataList .einvoiceDialog .el-dialog__title {
  color: white;
}
#eInvoiceDataList .einvoiceDialog .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#eInvoiceDataList .einvoiceDialog .el-dialog__body {
  padding: 3px 10px;
  font-size: 13px;
  /* font-family: "宋体"; */
}
#eInvoiceDataList .einvoiceDialog .fRemark > .el-textarea__inner {
  height: 100px;
}
#eInvoiceDataList .einvoiceDialog .fRemark_row .el-form-item__content {
  height: 100px;
}
#eInvoiceDataList .einvoiceDialog .fRemark_big > .el-textarea__inner {
  height: 135px;
}
#eInvoiceDataList .einvoiceDialog .fRemark_row_big .el-form-item__content {
  height: 135px;
}
#eInvoiceDataList .einvoiceDialog .el-input.is-disabled .el-input__inner,
#eInvoiceDataList .einvoiceDialog .el-textarea.is-disabled .el-textarea__inner {
  color: #606266;
}
</style>
<style scoped>
.el-form-item {
  margin-bottom: 5px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 200px;
}
.danger {
  color: #f56c6c;
}
.success {
  color: #67c23a;
}
</style>



// WEBPACK FOOTER //
// src/view/report/eInvoiceDataList.vue